import PackageGroup from '@/common/models/package-groups/PackageGroup';

import * as types from './mutation-types';

const mutations = {
  [types.SAVE_PACKAGE_GROUP](state: Record<number, PackageGroup>, packageGroup: PackageGroup) {
    state[packageGroup.id] = packageGroup;
  },

  [types.GET_PACKAGE_GROUP](state: Record<number, PackageGroup>, id: number): PackageGroup {
    return state[id];
  },
};

export default mutations;
